module.exports = __webpack_public_path__ + "img/section_apply.c0365225.jpg";